<template>
  <div class="d-inline">
    <button class="btn btn-ss" @click="$modal.show(name)">
      Export History
    </button>
    <div style="position: absolute">
      <vjs-modal :name="name"
                 title="Export Scheduler History"
                 icon="la la-download">
        <template #body-content>
          <div class="row">
            <div class="col-6">
              <label>Broadcast Start</label>
              <datetime id="broadcast_start"
                        v-model="broadcast_start"
                        name="Broadcast Start Time" input-class="form-control kt-input"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm:ss" />
            </div>
            <div class="col-6">
              <label>Broadcast Stop</label>
              <datetime id="broadcast_end"
                        v-model="broadcast_stop"
                        name="Broadcast Stop Time" input-class="form-control kt-input"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm:ss" />
            </div>
          </div>
        </template>

        <template #body-controls>
          <a :href="export_csv_url"
             :disabled="!can_submit"
             :class="`btn btn-ss-standout ${!can_submit ? 'disabled': ''}`">Export</a>
          <button type="button" class="btn btn-ss" @click="$modal.hide(name)">
            Cancel
          </button>
        </template>
      </vjs-modal>
    </div>
  </div>
</template>

<script>
import VjsModal from "VueModals/VjsModal";

export default {
  components: { VjsModal },
  props: {
    name: {
      type: String,
      required: false,
      default: 'export-scheduler-history',
    },
  },
  data() {
    return {
      broadcast_start: null,
      broadcast_stop: null,
    };
  },
  computed: {
    can_submit() {
      return this.broadcast_start && this.broadcast_stop;
    },
    export_csv_url() {
      return `/export-history?broadcast_start=${this.broadcast_start}&broadcast_end=${this.broadcast_stop}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.csv-export-root {
  display: inline-block;
}
</style>
